
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import lodash from 'lodash'

@Observer
@Component({})
export default class PageView extends Vue {
  @Prop({ default: {} }) model // 老手机以及验证码
  get PageStore() {
    return this.$store.$storeUser
  }
  codeType = 5 //3 绑定手机，4 绑定邮箱，5 更换手机，6 更换邮箱，7 手机找回密码，8 邮箱找回密码
  validDevice = false
  defaultValue = ''
  oldValue = ''
  get bind() {
    return {
      validDevice: this.validDevice,
      validExist: false,
      oldValue: this.oldValue,
      label: '手机号',
      btnText: '完成',
      layout: {
        labelCol: { span: 0 },
        wrapperCol: { span: 24 }
      },
      btnCol: { span: 24, offset: 0 }
    }
  }
  created() {
    let phone = lodash.get(this.PageStore, ['UserInfo', 'phoneNum'])
    if (phone || !phone) {
      this.validDevice = true
    }
  }
  // 验证原手机号
  async onSubmit(model) {
    try {
      // 5 更换手机
      if (this.model.oldPhoneNum === model.device) {
        this.$msg('请更换一个新的手机号', 'warning')
        return
      }
      if (lodash.eq(this.codeType, 5))
        await this.PageStore.onChangePhone(
          lodash.merge(this.model, {
            newPhoneNum: model.device,
            newPhoneVerifyCode: model.verifyCode
          })
        )
      await this.PageStore.onGetUserInfo()
      this.$msg(this.$EnumMessage.bind_success, 'info')
      this.PageStore.onChangeBindVisible(false)
    } catch (error) {
      if (lodash.eq(error, false)) this.$msg(this.$EnumMessage.check_code_error)
    }
  }
  async onSendSms(model, callback, closeLockCallback) {
    try {
      await this.PageStore.onGetCode({
        device: model.device,
        verifyCodeType: this.codeType
      })
      callback()
      closeLockCallback()
    } catch (error) {
      closeLockCallback()
      if (lodash.eq(error, false)) this.$msg(this.$EnumMessage.check_code_error)
    }
  }
}
